const index = [
  {
    name: 'security permissions',
    path: '/tenant-admin',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'security-permissions',
      allowedRoles: ['app-administrator', 'client-administrator', 'system-administrator'],
    },
    children: [
      {
        name: 'security permissions home',
        path: '/tenant-admin/security-permissions/',
        component: () =>
          import(
            '@/modules/security-permissions/containers/security-permissions.container.vue'
          ),
      },
    ],
  },
]

export default index
